// extracted by mini-css-extract-plugin
export var wrapper = "PartnerModule-module--wrapper--QLfBY";
export var container = "PartnerModule-module--container--spZ0v";
export var partnerModules = "PartnerModule-module--partnerModules--Pgd3V";
export var subtitleModule = "PartnerModule-module--subtitleModule--5X3im";
export var subtitleIcon = "PartnerModule-module--subtitleIcon--kcA0B";
export var partnerBlok = "PartnerModule-module--partnerBlok--lA-tA";
export var portret = "PartnerModule-module--portret--gZO6p";
export var contacts = "PartnerModule-module--contacts---gMK+";
export var name = "PartnerModule-module--name--vQoXV";
export var contact = "PartnerModule-module--contact--fe-e0";
export var icon = "PartnerModule-module--icon---tnZo";